import { z } from "zod";
import superjson from "superjson";
import { Selectable } from "kysely";
import { Notifications } from "../../helpers/schema";

export const schema = z.object({
  limit: z.coerce.number().default(20),
  offset: z.coerce.number().default(0),
  unreadOnly: z.coerce.boolean().optional(),
});

export type InputType = z.input<typeof schema>;

export type NotificationItem = Pick<
  Selectable<Notifications>,
  | "id"
  | "type"
  | "priority"
  | "title"
  | "message"
  | "link"
  | "isRead"
  | "createdAt"
  | "readAt"
  | "relatedEntityType"
  | "relatedEntityId"
>;

export type OutputType = {
  notifications: NotificationItem[];
};

export const getNotificationsList = async (
  params: InputType,
  init?: RequestInit
): Promise<OutputType> => {
  const searchParams = new URLSearchParams();
  if (params.limit) searchParams.set("limit", params.limit.toString());
  if (params.offset) searchParams.set("offset", params.offset.toString());
  if (params.unreadOnly !== undefined)
    searchParams.set("unreadOnly", params.unreadOnly.toString());

  const result = await fetch(
    `/_api/notifications/list?${searchParams.toString()}`,
    {
      method: "GET",
      ...init,
      headers: {
        "Content-Type": "application/json",
        ...(init?.headers ?? {}),
      },
    }
  );
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};